<script lang="ts">
	interface Props {
		href: string | undefined | null;
		children?: import('svelte').Snippet;
		onclick?: ((e: Event) => void) | null | undefined;
		'data-cy'?: string;
		class?: string;
		dataCy?: string;
		download?: string;
		rel?: string;
		target?: string;
		'aria-label'?: string;
		'aria-current'?: 'page' | 'step' | 'location' | 'date' | 'time' | true | false;
	}

	let { href, children, onclick, dataCy, ...rest }: Props = $props();
</script>

<a {onclick} {href} {...rest} data-cy={dataCy || rest['data-cy']}>
	{@render children?.()}
</a>
